<script>
import {VDataTable} from 'vuetify/lib';

export default {
  extends: VDataTable,
  name: 'data-table',
  mounted() {
    this.overridePaginationItems();
  },
  methods: {
    overridePaginationItems() {
      try {
        // console.debug('this.$children.length:', this.$children.length);
        const child1 = this.$children[0];
        // console.debug('child1.$children.length:', child1.$children.length);
        const child2 = child1.$children[0];
        // console.debug('child2.$children.length:', child2.$children.length);

        let child;

        for (let i = 0; i < child2.$children.length; i++) {
          child = child2.$children[i];

          if (child.$el.classList.contains('v-data-footer')) {
            break;
          }
        }

        const $dataFooter = child;
        // console.debug('$dataFooter:', $dataFooter);
        // console.debug('$dataFooter old itemsPerPageOptions:', JSON.stringify($dataFooter.itemsPerPageOptions));

        $dataFooter.itemsPerPageOptions.length = 0;
        $dataFooter.itemsPerPageOptions.push(25);
        $dataFooter.itemsPerPageOptions.push(50);
        $dataFooter.itemsPerPageOptions.push(100);

        // console.debug('$dataFooter new itemsPerPageOptions:', JSON.stringify($dataFooter.itemsPerPageOptions));
      } catch (error) {
        console.warn('Unable to override default pagination items due to an error:', error);
      }
    }
  }
};
</script>
